var React = require('react');

function InstagramCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"currentColor","key":0}),React.createElement("path",{"d":"M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z","fill":"#09143B","key":1}),React.createElement("path",{"d":"M14.4995 6H9.4995C7.57 6 6 7.5705 6 9.5005V14.5005C6 16.43 7.5705 18 9.5005 18H14.5005C16.43 18 18 16.4295 18 14.4995V9.4995C18 7.57 16.4295 6 14.4995 6ZM12 15C10.3455 15 9 13.6545 9 12C9 10.3455 10.3455 9 12 9C13.6545 9 15 10.3455 15 12C15 13.6545 13.6545 15 12 15ZM15.5 9C15.224 9 15 8.776 15 8.5C15 8.224 15.224 8 15.5 8C15.776 8 16 8.224 16 8.5C16 8.776 15.776 9 15.5 9Z","fill":"#09143B","key":2})]);
}

InstagramCircleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InstagramCircleInline;

InstagramCircleInline.default = InstagramCircleInline;
